const fr = {
    app: {
        lang: 'Français',
        edit_pwd: 'changer le mot de passe',
        logout: 'Se déconnecter',
        manage_title: 'Gérer le système',
        save: 'Sauvegarder',
        back: 'retour',
        operation: 'opérer',
        status: 'état',
        on: 'Activer',
        off: 'désactiver',
        search: 'Rechercher',
        order_no: 'numéro de commande',
        start_time: 'Heure de début',
        end_time: 'Heure de fin',
        id: 'ID',
        name: 'nom',
        username: 'identifiant',
        password: 'mot de passe',
        sort: 'trier',
        icon: 'icône',
        route: 'routage',
        desc: 'description',
        role: 'rôle',
        center: 'Centre de traitement',
        start: 'Commencer',
        complete: 'terminé',
        edit: 'modifier',
        del_tip: 'Voulez-vous vraiment supprimer ces données ?',
        del_m_tip: 'Voulez-vous vraiment supprimer ces données ?',
        tip: 'prompt',
        ok: 'Es-tu sûr',
        cancel: 'Annuler',
        list: 'liste',
        need_sel_one: 'sélectionnez au moins un',
    },
    login: {
        title: 'Administrateur',
        username: 'Nom d\'utilisateur',
        pwd: 'le mot de passe',
        verify: 'vérifier le code',
        remember: 'souviens-toi de moi',
        login: 'connexion',
    },
    admin: {
        edit_pwd: 'Changer le mot de passe',
        old_pwd: 'ancien mot de passe',
        new_pwd: 'nouveau mot de passe',
        confirm_pwd: 'Confirmez le mot de passe',
        re_pwd: 'Les mots de passe entrés deux fois ne correspondent pas!',
    },
    order: {
        list: 'Liste des commandes',
        ongoing: 'En cours',
    },
    user: {
        nickname: 'appeler',
        manage: 'Gestion des utilisateurs',
        edit: 'Modification de l’utilisateur'
    },
    flow: {
        user: 'opérateur',
        cart_no: 'Numéro de panier',
        box_num: 'Le nombre de carton',
        submit_user: 'opérateur',
    },
    ftype: {
        1: 'preparateur',
        2: 'contrôle',
        3: 'emballage',
        4: 'expedition',
    },
    wtype: {
        0: 'à preparer',
        1: 'à controler',
        2: 'à emballer',
        3: 'à expedier',
        4: 'terminé',
    },
    ontype: {
        0: 'preparer encour',
        1: 'contrôle encour',
        2: 'emballer encour',
        3: 'expedier encour',
    },
    menu: {
        'order': 'commandes',
        'stock': 'preparer',
        'check': 'contrôle',
        'pack': 'emballer',
        'close': 'expedier',
    },
}

export default fr;